import React from "react";
import Select, { components } from "react-select";
import Arrow from "@material-ui/icons/ArrowDropDown";
import restClient from "../common/restClient";
import tccStyles from "../common/styles";

// custom arrow matching mui styles
const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <Arrow />
            </components.DropdownIndicator>
        )
    );
};

class AutoCompleteInput extends React.Component {
    state = {
        data: [],
        selectValue: null,
        isLoading: true,
        page: 1,
        filter: null,
        search: null
    };

    componentDidMount() {}
    componentDidUpdate() {
        if (
            JSON.stringify(this.state.filter) !==
            JSON.stringify(this.props.filter)
        ) {
            this.props.input.value = null;
            this.setState(
                {
                    data: [],
                    selectValue: null,
                    search: null,
                    page: 1,
                    filter: this.props.filter
                },
                this.fetchData
            );
        }
    }
    getStyle = () => {
        const { meta } = this.props;
        return {
            menuPortal: provided => ({
                ...provided,
                zIndex: 9999
            }),
            option: (provided, state) => ({
                ...provided,
                color: tccStyles.colors.black,
                padding: 20,
                backgroundColor: state.isSelected
                    ? tccStyles.colors.lightgrey
                    : tccStyles.colors.white,
                ":active": {
                    backgroundColor:
                        state.isSelected || state.isFocused
                            ? tccStyles.colors.lightgrey
                            : tccStyles.colors.white
                },
                ":hover": {
                    backgroundColor: tccStyles.colors.lightgrey
                }
            }),
            control: (provided, state) => ({
                ...provided,
                borderRadius: 0,
                borderTop: state.isFocused ? 0 : 0,
                borderRight: state.isFocused ? 0 : 0,
                borderLeft: state.isFocused ? 0 : 0,
                borderBottom:
                    meta.error &&
                    meta.touched &&
                    this.state.selectValue &&
                    this.state.selectValue.length === 0
                        ? tccStyles.fields.borders.bottomBorderError
                        : tccStyles.fields.borders.bottomBorder,
                // This line disable the blue border
                boxShadow: state.isFocused ? 0 : 0,
                "&:hover":
                    meta.error &&
                    meta.touched &&
                    this.state.selectValue &&
                    this.state.selectValue.length === 0
                        ? tccStyles.fields.borders.bottomBorderError
                        : tccStyles.fields.borders.bottomBorderHover
            }),
            indicatorSeparator: () => ({
                display: "none"
            }),
            dropdownIndicator: (provided, state) => ({
                color: tccStyles.colors.main
            }),
            placeholder: (provided, state) => ({
                ...provided,
                // workaround for matching actual style
                marginLeft: -6.5,
                marginTop: 5
            }),
            menu: (provided, state) => ({
                ...provided,
                position: "absolute",
                zIndex: 1100
            }),
            singleValue: (provided, state) => ({
                ...provided,
                marginTop: 5,
                marginLeft: this.state.selected === false ? -6.5 : 0
            }),
            multiValue: (provided, state) => ({
                ...provided,
                borderRadius: 25,
                height: 32,
                textAlign: "center"
            }),
            multiValueLabel: (provided, state) => ({
                ...provided,
                marginTop: 5,
                color: tccStyles.colors.black
            })
        };
    };

    fetchData = () => {
        const { lazy } = this.props;
        if (!lazy) {
            this.setState(
                {
                    isLoading: true
                },
                () => {
                    const { options } = this.props;
                    const params = {
                        filter: {
                            ...this.props.filter,
                            name: this.state.search
                        },
                        pagination: { page: this.state.page, perPage: 10 },
                        sort: { field: options.display, order: "asc" }
                    };
                    restClient("GET_LIST", options.resource, params).then(
                        result => {
                            const fetchedData = result.data.map(item => {
                                return {
                                    value: item.id,
                                    label: item[options.display],
                                    data: item
                                };
                            });
                            const newData = [...this.state.data];
                            fetchedData.forEach(element => {
                                if (
                                    newData.findIndex(
                                        x => x.value === element.value
                                    ) === -1
                                ) {
                                    newData.push(element);
                                }
                            });
                            let defaultSelected = null;
                            if (this.state.selectValue != null) {
                                defaultSelected = newData.find(item => {
                                    return this.state.selectValue.value ===
                                        item.value
                                        ? item
                                        : null;
                                });
                            } else {
                                defaultSelected = newData.find(item => {
                                    return this.props.input.value === item.value
                                        ? item
                                        : null;
                                });
                            }
                            if (
                                defaultSelected === undefined &&
                                this.state.selectValue !== undefined
                            ) {
                                defaultSelected = this.state.selectValue;
                            }
                            this.setState(
                                {
                                    data: newData,
                                    isLoading: false,
                                    selectValue: defaultSelected
                                },
                                () => {
                                    if (
                                        fetchedData.length === 0 &&
                                        this.state.page > 1
                                    ) {
                                        this.setState({
                                            page: this.state.page - 1
                                        });
                                    }
                                }
                            );
                        },
                        error => {
                            this.setState({ isLoading: false });
                            return error;
                        }
                    );
                }
            );
        } else {
            const { values } = this.props;
            if (values !== null) {
                this.setState({ data: values, selectValue: null });
            }
        }
    };

    handleBlur = () => {
        this.props.input.onBlur();
        if (
            this.state.selectValue === null ||
            this.state.selectValue === undefined
        ) {
            this.setState({ search: "", page: 1, data: [] }, this.fetchData);
        }
    };

    handleChange = selected => {
        if (this.props.options.isMulti === true) {
            const values = selected.map(item => {
                return item.value;
            });
            values.length > 0
                ? this.props.input.onChange(values)
                : this.props.input.onChange(null);
        } else {
            this.props.input.onChange(selected.value);
        }
        this.setState({ selectValue: selected });
        if (this.props.onCustomerChanged) {
            this.props.onCustomerChanged(selected.value);
        }
        this.props.callBack && this.props.callBack(selected);
    };

    handleFocus = () => {};

    renderError() {
        return this.props.meta.touched &&
            this.props.meta.error &&
            this.state.selectValue &&
            this.state.selectValue.length === 0 ? (
            <div
                style={{
                    fontSize: "16px",
                    color: tccStyles.colors.error
                }}
            >
                {this.props.meta.error}
            </div>
        ) : null;
    }

    renderLabel() {
        const { label } = this.props.options;
        return (
            <div
                style={{
                    fontSize: "12px",
                    color:
                        this.props.meta.touched &&
                        this.props.meta.error &&
                        this.state.selectValue &&
                        this.state.selectValue.length === 0
                            ? tccStyles.colors.error
                            : tccStyles.colors.main,
                    visibility:
                        this.props.meta.pristine === true &&
                        this.state.selected === false
                            ? "hidden"
                            : null
                }}
            >
                {`${label} *`}
            </div>
        );
    }

    renderPlaceholder() {
        const { label } = this.props.options;
        return (
            <div
                style={{
                    fontSize: "16px",
                    color:
                        this.props.meta.touched &&
                        this.props.meta.error &&
                        this.state.selectValue &&
                        this.state.selectValue.length === 0
                            ? tccStyles.colors.error
                            : tccStyles.colors.main,
                    visibility:
                        this.state.selectValue !== null ? "hidden" : null
                }}
            >
                {`${label} *`}
            </div>
        );
    }

    loadMore = () => {
        this.setState(
            {
                page: this.state.page + 1
            },
            this.fetchData
        );
    };

    inputChange = (s, event) => {
        if (event.action === "input-change") {
            this.setState({ data: [], page: 1, search: s }, this.fetchData);
        }
    };

    render() {
        return (
            <div>
                <div>{this.renderLabel()}</div>
                <Select
                    onFocus={this.handleFocus}
                    components={{ DropdownIndicator }}
                    styles={this.getStyle()}
                    value={this.state.selectValue}
                    onChange={this.handleChange}
                    options={this.state.data}
                    placeholder={this.renderPlaceholder()}
                    onBlur={this.handleBlur}
                    isMulti={this.props.options.isMulti}
                    isClearable={false}
                    isLoading={this.state.isLoading}
                    isDisabled={this.props.disabled}
                    menuPortalTarget={document.body}
                    onMenuScrollToBottom={this.loadMore}
                    onInputChange={this.inputChange}
                />
                <div>{this.renderError()}</div>
            </div>
        );
    }
}

export default AutoCompleteInput;



// WEBPACK FOOTER //
// ./src/components/AutoCompleteInput.js